import CharacterCard from "@/components/character/CharacterCard";
import { Nav } from "@/components/Nav";
import { useAuth } from "@/hooks/auth/useAuth";
import { useAvailableCharacters } from "@/hooks/useCharacters";
import { supabase } from "@/integrations/supabase/client";
import { useQuery } from "@tanstack/react-query";
import { Loader2 } from "lucide-react";

const NewConversation = () => {
  const { user } = useAuth();

  // Fetch character_ids with existing conversations
  const { data: existingCharacterIds, isLoading: isConversationsLoading } =
    useQuery({
      queryKey: ["existing-conversations", user?.id],
      queryFn: async () => {
        if (!user?.id) return [];
        const { data, error } = await supabase
          .from("chat_history")
          .select("character_id")
          .eq("profile_id", user.id);
        if (error) throw error;
        // Return unique character_ids
        return Array.from(new Set((data ?? []).map((row) => row.character_id)));
      },
      enabled: !!user?.id,
    });

  // Fetch available characters (not in existing conversations)
  const {
    data: characters,
    isLoading: isCharactersLoading,
    error,
  } = useAvailableCharacters(existingCharacterIds ?? []);

  return (
    <div className="gradient-bg min-h-full">
      {/* Navigation */}
      <Nav showBack />
      <main className="mx-auto max-w-2xl px-4 py-4 sm:px-6 lg:px-8">
        {isConversationsLoading ||
          (isCharactersLoading && (
            <div className="animate-fade-in flex flex-col items-center justify-center py-24 text-center text-gray-400">
              <Loader2 className="mx-auto mb-4 h-8 w-8 animate-spin text-indigo-600" />
            </div>
          ))}
        {error && (
          <div className="animate-fade-in flex flex-col items-center justify-center py-24 text-center text-gray-400">
            <p className="mb-4 text-red-700">
              Erreur lors du chargement des personnages
            </p>
          </div>
        )}
        {characters && characters.length > 0 ?
          <div className="mx-auto mb-16 grid gap-6 md:grid-cols-2">
            {characters.map((character, index) => (
              <CharacterCard
                key={character.id}
                character={character}
                index={index}
              />
            ))}
          </div>
        : <div className="py-16 text-center">
            <p className="text-lg text-gray-600">
              Aucun personnage disponible pour le moment.
            </p>
          </div>
        }
      </main>
    </div>
  );
};

export default NewConversation;
